import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ActionMessage, TypeMessage } from '../../../entity/enum/enum-notification';
import { NotificationService } from '../../../services/notification.service';
import { MyErrorStateMatcher } from '../../../util/my-error-state-matcher';
import { FormuleConfig } from '../model/FormuleConfig';
import { FormuleConfigService } from '../service/formule-config.service';
import * as moment from 'moment';
import { Route } from '@angular/compiler/src/core';
import { GeneralService } from 'src/app/services/general.service';
import { take } from 'rxjs/operators';


@Component({
  selector: 'app-formule-config-add',
  templateUrl: './formule-config-add.component.html',
  styleUrls: ['./formule-config-add.component.scss'],
})
export class FormuleConfigAddComponent implements OnInit {
  form: FormGroup;
  matcher: any;
  user: string = '';
  isEdit: boolean = false;
  isOff: boolean = false;
  objEdit: FormuleConfig;

  constructor(
    private _fb: FormBuilder,
    private router: Router,
    private notificationService: NotificationService,
    private service: FormuleConfigService,
    private route: ActivatedRoute,
    private generalService: GeneralService
  ) {}

  ngOnInit(): void {
    this.createForm();
    this.isCheckEdit();
  }

  getUserName = async () => {
    await this.generalService
      .getUserNameValue()
      .pipe(take(1))
      .toPromise()
      .then((name: string) => {
        this.user = name;
      });
  };

  createForm = () => {
    this.form = this._fb.group({
      id: [null],
      name: [null, Validators.required],
      desc: [null, Validators.required],
      sql: [null, Validators.required],
    });
  };

  back() {
    this.router.navigateByUrl('/formule-config');
  }

  populateModel = () => {
    let obj = new FormuleConfig();

    if (!this.isEdit) {
      obj.created_at = moment(new Date()).format('YYYY-MM-DD');
      obj.user_created = this.user;
      obj.active = true;
    } else {
      obj.created_at = this.objEdit.created_at;
      obj.user_created = this.objEdit.user_created;      
    }

    obj.id = this.form.controls.id.value;
    obj.updated_at = moment(new Date()).format('YYYY-MM-DD');
    obj.name = this.form.controls.name.value;
    obj.description = this.form.controls.desc.value;
    obj.formule_sql = this.form.controls.sql.value;
    obj.user_updated_at = this.user;

    return obj;
  };

  isCheckEdit = () => {
    this.route.paramMap.subscribe(async (paramMap) => {
      let id = paramMap.get('id');
      let off = paramMap.get('off');

      if (off !== 'undefined' && off !== 'false') {
        this.isOff = true;
      }

      if (id !== undefined && id !== null) {
        this.isEdit = true;
        if (!this.isOff) {
          await this.getById(Number(id));
        } else {
          await this.getByIdOff(id);
        }
      }

      await this.getUserName();
    });
  };

  getByIdOff = async (name: string) => {
    const data_offline = await this.generalService.getDataFromLocalStorage('formule-config');
    if (data_offline?.length > 0) {
      let formuleConfig = data_offline.find(a => a.name === name);
      this.populateFormEdit(formuleConfig);
    }
  }

  getById = async (id: number) => {
    await this.service
      .getById(id)
      .then((node) => {
        this.populateFormEdit(node[0]);
      })
      .catch((err) => console.error(err));
  };

  populateFormEdit = (obj: FormuleConfig) => {
    this.objEdit = obj;
    this.form.controls.id.setValue(obj.id);
    this.form.controls.name.setValue(obj.name);
    this.form.controls.desc.setValue(obj.description);
    this.form.controls.sql.setValue(obj.formule_sql);
  };

  saveAll = () => {
    if (this.isOff) {
      this.saveOff();
    } else {
      this.save();
    }
  }

  saveOff = async() => {
    this.matcher = new MyErrorStateMatcher();
    const data_offline = await this.generalService.getDataFromLocalStorage('formule-config');
    if (this.form.valid) {
      let obj = this.populateModel();
      obj.isOff = true;
      if (this.isEdit) {
        let listOff:FormuleConfig[] = data_offline.filter(a => a.name !== this.objEdit.name);        
        listOff.push(obj);
        localStorage.setItem('data_formule-config', JSON.stringify(listOff));
        this.notificationService.sendNotification(
          null,
          TypeMessage.Edit,
          ActionMessage.Success
        );
      } else {
        data_offline.push(obj);
        localStorage.setItem('data_formule-config', JSON.stringify(data_offline));
        this.notificationService.sendNotification(
          null,
          TypeMessage.New,
          ActionMessage.Success
        );
      }

      this.back();
     } else {
      this.notificationService.sendNotification(
        null,
        TypeMessage.FormInvalid,
        ActionMessage.Warning
      );
     }
  }

  save() {
    this.matcher = new MyErrorStateMatcher();

    if (this.form.valid) {
      let obj = this.populateModel();
      this.service
        .saveOrUpdate(obj)
        .then((res) => {
          if (!this.isEdit) {
            this.notificationService.sendNotification(
              null,
              TypeMessage.New,
              ActionMessage.Success
            );
          } else {
            this.notificationService.sendNotification(
              null,
              TypeMessage.Edit,
              ActionMessage.Success
            );
          }

          this.back();
        })
        .catch((err) => console.error(err));
    } else {
      this.notificationService.sendNotification(
        null,
        TypeMessage.FormInvalid,
        ActionMessage.Warning
      );
    }
  }
}
